import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead,
   TableRow, Paper, Chip,AppBar, Typography, Container, Toolbar, Box, Tooltip, IconButton,Avatar, Menu,
    MenuItem, Divider, Button, CircularProgress } from '@mui/material';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { SxProps } from '@mui/system';  
import Fab from '@mui/material/Fab';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import HelpIcon from '@mui/icons-material/Help';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {theme} from '../helpers/colors'
import {stringAvatar,getStatusChipProps,processCSV} from '../helpers/utils'
import Fuse from 'fuse.js';
import _ from 'lodash';
import moment from 'moment';
import {generateClient} from 'aws-amplify/api';
import {CSVImporter} from "csv-import-react";
import {Amplify,Auth} from 'aws-amplify';
import { signOut } from 'aws-amplify/auth';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import cdkOutputs from '../helpers/cdk-output.json';
import csvButtonImage from '../images/csv_button.PNG';
import deactivateButtonImage from '../images/deactivateButton.PNG';
import historyButtonImage from '../images/HistoryButton.PNG';
import historyScreenshotImage from '../images/HistoryScreenshot.PNG';
import searchbarImage from '../images/searchbar.PNG';

//import { log } from 'console';

const LOGOUT_STRING='Logout';
const HISTORY_STRING='History';
const settings = [HISTORY_STRING,LOGOUT_STRING];
const STACK_NAME="DelegationCleanupStack"
const TablePage = ({ fullName }) => {

    const [data, setData] = React.useState([]);
    const IDENTITY_NAME = fullName;

    const fuseOptions = {
    includeScore: true,
    includeMatches: true,
    keys: ['userId', 'name', 'privilegeName', 'privilegeId', 'status'],
    threshold: 0.4
    };
    
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [fuse, setFuse] = React.useState(new Fuse(data, fuseOptions));
    const [isOpenCSVSelector, setIsOpenCSVSelector] = useState(false);
    const [loading, setLoading] = React.useState(false); // Add a loading state
    const [open, setOpen] = React.useState(false);
    const [csvData,setcsvData] = React.useState([]);
    const [isTutorialOpen, setIsTutorialOpen] = useState(false);


    const clientGraphQL = generateClient();

    const navigate = useNavigate();
  
    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
    const handleClickHistory = () => {
      navigate('/history');
    }
    const handleCloseSnackBar = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
  
      setOpen(false);
    };
  
    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };
  
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };
    
    const handleClose = (isClosed) => {
      if (isClosed)
        setIsTutorialOpen(false);
    };
   
    async function handleSignOut() {
      try {
        await signOut();
      } catch (error) {
        console.log('error signing out: ', error);
      }
    }


    const fetchPrivilegesQuery = { 
      query : `
        query FetchPrivileges {
          fetchPrivileges {
            code
            usersData {
              userRolePermissionId
              userId
              roleId
              email
              last_login
              name
              privilegeId
              privilegeName
              status
              lastDeactivated
              last_login_deactivation
            }
          }
        }
      `,
      authMode: 'userPool'
    };

    async function fetchPrivileges() {
      setLoading(true);
      try {
        const result = await clientGraphQL.graphql(fetchPrivilegesQuery);
        console.log('Query result:', result);
        setData(result.data.fetchPrivileges.usersData);
      } catch (error) {
        console.error('Error calling query:', error);
      } finally {
        setLoading(false); // Set loading to false when data is fetched or error occurs
      }
    }

    const Highlight = ({ text = '', indices = [] }) => {
        const parts = indices.reduce((parts, [start, end], index) => {
          const prev = indices[index - 1];
          const prevEnd = prev ? prev[1] + 1 : 0;
          parts.push(text.slice(prevEnd, start));
          parts.push(<strong key={index}>{text.slice(start, end + 1)}</strong>);
          if (index === indices.length - 1) {
            parts.push(text.slice(end + 1));
          }
          return parts;
        }, []);
      
        return parts.length > 0 ? <span>{parts}</span> : <span>{text}</span>;
      };
    
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState(data.map(item => ({ item, matches: {} })));
  const fabStyle = {
    bgcolor:'#FBFAF2',
    position: 'absolute',
    '&:hover':{
      bgcolor:'white'
    },
    bottom: 16,
    right: 16,
    color:'black'
  };
  const fab ={
    sx: fabStyle,
    icon: <HelpIcon />,
    label: 'Add',
  };

  const debouncedSearch = useCallback(_.debounce((query) => {
    const searchResults = query ? fuse.search(query).map(result => ({
      item: result.item,
      matches: result.matches.reduce((acc, match) => {
        acc[match.key] = match.indices;
        return acc;
      }, {})
    })) : data.map(item => ({ item, matches: {} }));
    setResults(searchResults);
  }, 250), [fuse]);

  useEffect(() => {
    if (data.length > 0) {
      setFuse(new Fuse(data, fuseOptions));
      setResults(data.map(item => ({ item, matches: {} })));
    }
  }, [data]);


  useEffect(() => {
    debouncedSearch(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    fetchPrivileges();
  }, []);


  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
    <ThemeProvider theme={theme}>
      <AppBar position="static">
      <Container maxWidth="xl">
      <Toolbar disableGutters>
        <svg xmlns="http://www.w3.org/2000/svg" className='airbus-icon' width="126" height="24" viewBox="0 0 640 121.8344">
                <defs id="defs4"></defs>
                <g id="g44809" transform="matrix(5.5695687,0,0,5.5695687,-2558.8034,-4448.4754)">
                    <path d="m 526.05468,815.67559 -7.26563,0 0,-4.07812 7.26953,0 c 1.19532,0.0195 2.16016,0.91406 2.16016,2.03125 0,1.11719 -0.96875,2.04687 -2.16406,2.04687 m -7.26563,-11.95703 7.14063,0 c 0.97656,0.0117 1.80468,0.76563 1.80468,1.75391 0,0.98437 -0.86718,1.76953 -1.84765,1.75781 l -7.09766,0 z m 11.3711,5.70313 c 1.34375,-0.94531 1.85156,-2.51172 1.85156,-4.23438 0,-3.24218 -2.73047,-5.83984 -6.07813,-5.83984 l -12.125,0 0,20.69922 12.60157,0 0,0.008 c 3.53906,0 6.48437,-2.73047 6.48437,-6.07422 0,-2.17969 -1.3125,-3.79297 -2.73437,-4.55859 m 18.69921,-10.1211 0,11.63672 c 0,3.5586 -2.07812,5.05078 -4.63281,5.05078 -2.55859,0 -4.62109,-1.48828 -4.62109,-5.04687 l 0,-11.64063 -5.16016,0 0,11.67188 c 0,7.44531 4.375,9.61328 9.78125,9.61328 5.41016,0 9.78906,-2.16797 9.78906,-9.61328 l 0,-11.67188 z m 18.10547,8.06641 c -4.17578,-0.90625 -5.58593,-1.30859 -5.58593,-2.63281 0,-1.16797 1.51171,-1.75781 3.89843,-1.75781 2.25391,0 4.97657,0.96093 6.57422,1.91796 l 1.62891,-4.21093 c -2.42188,-1.00782 -5.33594,-1.97266 -9.1875,-1.97266 -5.05078,0 -8.20313,2.95313 -8.20313,6.5625 0,3.61328 2.59766,5.20313 7.7461,6.29297 3.99218,0.84375 5.07422,1.35156 5.07422,2.59375 0,1.24219 -1.60157,1.69922 -3.76563,1.69922 -2.80078,0 -5.49609,-0.9336 -8.03516,-2.02344 l -1.53515,4.10528 c 3.03515,1.40625 6.1875,2.53516 9.94531,2.53516 6.26172,0 8.81641,-2.99219 8.81641,-6.48047 0,-3.10157 -2.14844,-5.49219 -7.3711,-6.62891 m -97.08203,-8.01953 -10.45703,20.69531 6.21094,0.004 1.5625,-3.32813 7.13281,0 -2.21875,-4.53515 -2.81641,0 2.65235,-5.66016 6.67969,13.52344 6.22656,0 -10.86328,-20.69922 z m 42.01563,6.88281 c 0,-3.76953 -2.58594,-6.82812 -7.90235,-6.82812 l -10.73828,0 0,20.69922 4.97656,-0.004 0,-16.32422 6.10547,0 c 1.80469,0 2.55469,1.11719 2.55469,2.44531 0,1.33203 -0.78906,2.39844 -2.59375,2.39844 l -4.26953,0 6.46094,11.48047 5.10937,0 c 0,0 -4.42187,-7.50391 -4.39844,-7.50781 3.19141,-0.99219 4.69532,-3.41016 4.69532,-6.35938 m -25.97657,13.82422 5.14844,0 0,-20.69531 -5.14844,0 z" id="path28794" ></path>
                </g>
            </svg>
          
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 2, flexGrow: 1 }}>
              <Typography variant="h6" noWrap component="div" sx={{ fontFamily: 'monospace', fontWeight: 700, letterSpacing: '.3rem', color: 'inherit', textDecoration: 'none' }}>
              Privilege Cleaner
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Typography variant="caption" component="div" sx={{ fontStyle: 'italic' }}>
              {cdkOutputs[STACK_NAME].env}
              </Typography>
              </Box>
            </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            </Box>

          <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar  alt={IDENTITY_NAME} {...stringAvatar(IDENTITY_NAME)} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              PaperProps={{  
                style: {  
                  width: 250,  
                },  
             }} 
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
                <Box elevation={3} sx={{  display: 'flex',justifyContent: 'center', }}>
                    <Avatar  style={{margin:'20px'}} alt={IDENTITY_NAME} {...stringAvatar(IDENTITY_NAME)} />
                    <span style={{margin:'20px'}}>{IDENTITY_NAME}</span>
                </Box>
                <Divider/>
                {settings.map((setting) => (
                  <MenuItem
                    sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}
                    key={setting}
                    onClick={setting === LOGOUT_STRING ? handleSignOut : (setting === HISTORY_STRING ? handleClickHistory: handleCloseUserMenu)}
                  >
                    <Typography sx={{ width: '100%' }} textAlign="center">
                      {setting}
                    </Typography>
                  </MenuItem>
                ))}
            </Menu>
          </Box>
          </Toolbar>
          </Container>
      </AppBar>
      </ThemeProvider>
    
      <div style={{ marginTop:10, marginRight:3, display: 'flex', alignItems: 'center' }}>
      <TextField
        label={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SearchIcon style={{ marginRight: 8 }} />
            Search
          </div>
        }
        variant="outlined"
        fullWidth
        style={{ flex: 1, marginRight: 8 }}
        onChange={e => setSearchTerm(e.target.value)}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={() => setIsOpenCSVSelector(true)}
        startIcon={<AddIcon />}
      >
        Import CSV
      </Button>
      
      <CSVImporter
        modalIsOpen={isOpenCSVSelector}
        modalOnCloseTriggered={() => setIsOpenCSVSelector(false)}
        darkMode={true}
        onComplete={(data) => { 
          const finalData = data.rows.map(row => parseInt(row.values.userId));
          console.log(finalData);
          setcsvData(finalData);
          processCSV(finalData,clientGraphQL);
          setIsOpenCSVSelector(false);
          setOpen(true);
        }}
        template={{
          columns: [
            {
              name: "userId",
              key: "userId",
              required: true,
              description: "The Onelogin Id of the user"
            }
          ],
        }}
      />
      <Snackbar open={open} onClose={handleCloseSnackBar} autoHideDuration={2000}>
        <Alert
          onClose={handleCloseSnackBar}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          {csvData.length === 1
            ? 'The user will be deleted in few minutes. Please wait and refresh the page to check the status.'
            : `The ${csvData.length} users will be deleted in few minutes. Please wait and refresh the page to check the status.`}
        </Alert>
      </Snackbar>
    </div>
   
      <TableContainer component={Paper} style={{ flex: 1 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">User ID</TableCell>
              <TableCell align="right">Privilege</TableCell>
              <TableCell align="right">Privilege ID</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="right">Last Login</TableCell>
              <TableCell align="right">Privilege Lost</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading ? ( // Conditionally render the spinner
                <TableRow>
                  <TableCell colSpan={7} style={{ textAlign: 'center' }}>
                    <CircularProgress /> 
                  </TableCell>
                </TableRow>
              ) : (
                results.map((result, index) => (
                <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                  <TableCell component="th" scope="row">
                    <Link to={`/details/${result.item.userId}`} state={{ item: result.item }} style={{ textDecoration: 'none', color: 'inherit' }}>
                      <Highlight text={result.item.name} indices={result.matches.name || []} />
                    </Link>
                  </TableCell>
                  <TableCell align="right">
                    <Highlight text={result.item.userId?result.item.userId.toString():'null'} indices={result.matches.userId || []} />
                  </TableCell>
                  <TableCell align="right">
                    <Highlight text={result.item.privilegeName} indices={result.matches.privilegeName || []} />
                  </TableCell>
                  <TableCell align="right">
                    <Highlight text={result.item.privilegeId?result.item.privilegeId.toString():'null'} indices={result.matches.privilegeId || []} />
                  </TableCell>
                  <TableCell align="center">
                    <Chip {...getStatusChipProps(result.item.status, result.item.last_login)} />
                  </TableCell>
                  <TableCell align="right">
                    {result.item.last_login}
                  </TableCell>
                  <TableCell align="right">
                    {result.item.lastDeactivated}
                  </TableCell>
                </TableRow>
              )))}
            </TableBody>
        </Table>
      </TableContainer>
      <Fab 
        onClick={() => setIsTutorialOpen(true)}
        sx={fab.sx} aria-label={fab.label} color="white">
            {fab.icon}
      </Fab>
      <TutorialModal isOpen={isTutorialOpen} setIsOpen={setIsTutorialOpen} onClose={handleClose} />
    </div>
  );
};
const FullWidthImage = styled('img')({
  maxWidth: '80%',
  maxHeight: '30%',
  height: 'auto',
  display: 'block',
  marginBottom: '1rem',
  marginLeft:'auto',
  marginRight:'auto'
});

const ImageContainer = styled('div')({
  marginBottom: '1rem',
});

const ImageLabel = styled(Typography)({
  textAlign: 'center',
  fontStyle: 'italic',
  color: 'rgba(0, 0, 0, 0.6)',
});

const TutorialModal = ({ isOpen, onClose }) => {
  const handleClose = () => {
    onClose(true);
  };
    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      minwidth:"80%"
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '70%',
        maxWidth: '70%',  // Overrides default max-width
        margin: '16px',   // Adds some margin around the dialog
      },
    }
  }));

  const TutorialContent = styled(Typography)({
   fontSize:"1.3vW"
  });

  

  if (!isOpen) return null;

  return   <BootstrapDialog
  onClose={handleClose}
  aria-labelledby="customized-dialog-title"
  open={isOpen}
>
  <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
    Help
  </DialogTitle>
  <IconButton
    aria-label="close"
    onClick={handleClose}
    sx={{
      position: 'absolute',
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500],
    }}
  >
    <CloseIcon />
  </IconButton>
  <DialogContent dividers>
    <Typography variant="h5" gutterBottom>
      Search Bar
    </Typography>
    <TutorialContent gutterBottom>
      The search bar is used for searching users who have a privilege set.
      It uses the data that was retrieved during the first run.
      <ImageContainer>
      <FullWidthImage src={searchbarImage} alt="Search bar" loading="lazy" />
      <ImageLabel>Figure 1: Search bar for finding users with privileges</ImageLabel>
    </ImageContainer>
      If a new user has been granted a privilege, they will be retrievable
      from the search bar the following week (after the weekly run on Sundays).
    </TutorialContent>
    <Typography variant="h5" gutterBottom>
      Deactivation
    </Typography>
    <TutorialContent gutterBottom>
      You can deactivate privileges for a user by either searching for their
      account in the table and then deactivating them by clicking on the deactivate
      button, or by including their account ID in a CSV file.
      <ImageContainer>
      <FullWidthImage src={deactivateButtonImage} alt="Deactivate button" loading="lazy" />
      <ImageLabel>Figure 2: Deactivate button for revoking user privileges</ImageLabel>
    </ImageContainer>
     The CSV method
      allows deactivation in batches.
    </TutorialContent>
    <ImageContainer>
      <FullWidthImage src={csvButtonImage} alt="CSV button" loading="lazy" />
      <ImageLabel>Figure 3: CSV button for batch deactivation of privileges</ImageLabel>
    </ImageContainer>
    <Typography variant="h5" gutterBottom>
      History
    </Typography>
    <TutorialContent gutterBottom>
      You can review the history of deactivations by clicking on your avatar and then
      on the history button. 
      <ImageContainer>
      <FullWidthImage src={historyButtonImage} alt="History button" loading="lazy" />
      <ImageLabel>Figure 4: History button to access deactivation records</ImageLabel>
    </ImageContainer>
    You will then find all accounts deactivated by date. If
      you see an account being reported in multiple weeks, it's probably due to its
      license being deactivated. Any action on a deactivated account is ignored by
      OneLogin.
    </TutorialContent>
    <ImageContainer>
      <FullWidthImage src={historyScreenshotImage} alt="History screenshot" loading="lazy" />
      <ImageLabel>Figure 5: Screenshot of the deactivation history page</ImageLabel>
    </ImageContainer>
  </DialogContent>
</BootstrapDialog>
  
};
export default TablePage;